module.exports = __webpack_public_path__ + "static/hero-b3db9f7c382731ef55719440b19ec4ae.png";